import { render, staticRenderFns } from "./AMPMAP.vue?vue&type=template&id=fb2ccb3a&"
import script from "./AMPMAP.vue?vue&type=script&lang=js&"
export * from "./AMPMAP.vue?vue&type=script&lang=js&"
import style0 from "./AMPMAP.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports